// 消息模板列表
export const messageTemplates = [
  { label: '超速提醒', content: '您已超速，请控制车速，保持安全车速，严禁疲劳驾驶。' },
  { label: '疲劳驾驶', content: '您已连续驾驶时间过长，请尽快停车休息，严禁疲劳驾驶。' },
  { label: '车距提醒', content: '请注意保持安全车距，减速慢行。' },
  { label: '路面提醒', content: '请注意观察路面情况，保持车距，减速慢行，严禁疲劳驾驶。' },
  { label: '司机提醒', content: '请驾驶员注意路面情况，谨慎驾驶，确保行车安全。' },
  { label: '严禁疲劳驾驶', content: '请驾驶员提高警惕，保持安全车速，严禁疲劳驾驶！' },
  { label: '阴天有雾', content: '阴天有雾，视线不佳，请驾驶员注意观察路面情况，保持车距，小心驾驶。' },
  { label: '雨天路滑', content: '雨天路滑，请保持安全车速，减速慢行，注意行车安全。' },
  { label: '雨雪天气', content: '雨雪天气，路面湿滑，请减速慢行，保持安全车距，谨慎驾驶。' },
  { label: '夜间行驶', content: '夜间行驶视线不佳，请驾驶员注意观察路况，合理使用灯光，谨慎驾驶。' },
  { label: '施工路段', content: '前方施工路段，请减速慢行，注意避让，安全通过。' },
  { label: '高速公路', content: '高速公路行驶，请保持安全车距，切勿超速，严禁随意变道。' },
  { label: '安全检查', content: '请驾驶员在发车前对车辆进行安全检查，确保车辆状况良好。' },
  { label: '春运提醒', content: '春运期间客流量大，请驾驶员提高警惕，保持安全车速，注意行车安全。' },
  { label: '偏航提醒', content: '您已偏离规划路线，请及时调整行驶路线。' },
  { label: '紧急通知', content: '紧急通知：请驾驶员立即靠边停车，等待进一步指示。' },
];
